module.exports = {
      id: "messenger-usage",
      viewBox: "0 0 28 28",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#messenger",
      toString: function () {
        return this.url;
      }
    }